import React, { Component } from 'react';
import classNames from 'classnames';

import store from 'store/index';
import StoreGetters from 'store/store-getters';

import { Trans } from 'react-i18next';
import { ReactComponent as StyleToggle_icon_single } from 'asset/image/styleToggle_icon_single.svg';
import { ReactComponent as StyleToggle_icon_double } from 'asset/image/styleToggle_icon_double.svg';
import multiStyle_icon from 'asset/image/multiStyle_icon.svg';
import closeIcon from 'asset/image/multiStyle_close_icon.svg';
import CloseIconHover from 'asset/image/icons-close-hover.svg';
import { ReactComponent as MultiStyle_close_icon } from 'asset/image/multiStyle_close_icon.svg';
import { VIEW } from '../config';
import { STATE } from 'services/3dviewer/moving-controls/synchronizeController';

export default class StyleSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      styles: null,
      selectIndex: 1,
      isDoubleHover: false,
      isFullHover: false,
      isFPview: false,
    };
  }

  componentDidMount() {
    store.subscribe(this.setStyleList);
  }

  changeStyle = mode => {
    this.props.parent.changeView(mode);
  };

  changeStyleIndex = index => {
    this.props.parent.changeSecondStyle(index);
    this.setState({
      selectIndex: index,
    });
  };

  setStyleList = () => {
    const floorStyle = StoreGetters.getCurrentRenderFloorStyles();

    const { viewButton } = store.getState();
    if (viewButton) {
      const { viewState } = viewButton;
      this.setState({
        styles: floorStyle,
        isFPview: viewState == STATE.FPVIEW,
      });
    }
  };

  toggleStyle() {
    if (this.props.mode == VIEW.RIGHTFULL) {
      this.changeStyle(VIEW.DOUBLE);
    } else if (this.props.mode == VIEW.DOUBLE) {
      this.changeStyle(VIEW.RIGHTFULL);
    }
  }

  render() {
    const RWD = this.props.RWD == 'PC' ? '' : '-mobile';
    return (
      <>
        {this.state.isFPview && (
          <>
            <div>
              {this.props.mode == VIEW.SINGLE ? (
                <div className={'select-style-board-close-1' + RWD}>
                  <button
                    className="select-style-board-close_1-mobile"
                    onClick={() => this.changeStyle(VIEW.DOUBLE)}
                  >
                    <img src={multiStyle_icon} />
                    <span className="select-style-button-name-mobile">
                      <Trans>Style</Trans>
                    </span>
                  </button>
                </div>
              ) : (
                <div className={'select-style-board-close-1' + RWD}>
                  <button
                    className="select-style-board-close_1-mobile"
                    onClick={() => this.changeStyle(VIEW.SINGLE)}
                    style={{ backgroundColor: 'transparent' }}
                  >
                    <img
                      src={closeIcon}
                      style={{ marginTop: '7px', marginLeft: '30px' }}
                    />
                    <span
                      className="select-style-button-name-mobile"
                      style={{
                        top: '14%',
                        color: '#F05A5A',
                        marginLeft: '-3px',
                      }}
                    >
                      <Trans>Back</Trans>
                    </span>
                  </button>
                </div>
              )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {this.props.mode != VIEW.SINGLE && (
                <div className="select-style-board-div-mobile">
                  {
                    <div
                      style={{
                        top: '4px',
                        margin: '2px 6px 2px 6px',
                        backgroundColor: 'transparent',
                        borderRadius: '50px',
                        position: 'relative',
                      }}
                    >
                      <div
                        className={'select-style-board-open-1' + RWD}
                        style={{
                          top: '3px',
                          margin: '0 20px 0 20px',
                          backgroundColor: 'transparent',
                        }}
                      >
                        <div style={{ display: 'inline-flex' }}>
                          {this.state.styles != null &&
                            Object.keys(this.state.styles).map((b, index) => {
                              if (index != 0) {
                                var styleClass = classNames({
                                  'select-style-board_2': true,
                                  selected: this.state.selectIndex == index,
                                });
                                return (
                                  <button
                                    className={styleClass}
                                    key={index}
                                    onClick={() => this.changeStyleIndex(index)}
                                  >
                                    <span className="select-style-button-name-1">
                                      <Trans>
                                        {' '}
                                        {this.state.styles[b].name}
                                      </Trans>
                                    </span>
                                  </button>
                                );
                              }
                            })}
                        </div>
                      </div>
                    </div>
                  }
                  {this.props.mode == VIEW.DOUBLE ? (
                    // <div className={"select-style-board-open-1" + RWD} style={{ position: 'absolute' ,borderRadius:"0"}}>
                    <button
                      className="changeStyleIcon_double-mobile"
                      onClick={() => this.toggleStyle()}
                    >
                      <StyleToggle_icon_single className="toggleStyleIcon" />
                    </button>
                  ) : (
                    // </div>
                    <button
                      className="changeStyleIcon_single-mobile"
                      onClick={() => this.toggleStyle()}
                    >
                      <StyleToggle_icon_double className="toggleStyleIcon" />
                    </button>
                  )}
                  {
                    <div
                      className={
                        this.props.mode == VIEW.RIGHTFULL
                          ? 'select-style-signal-rightfull'
                          : 'select-style-signal-double select-style-signal-double--mobile'
                      }
                      style={{ top: '68px' }}
                    >
                      After
                    </div>
                  }
                </div>
              )}
            </div>
          </>
        )}
      </>
    );
  }
}
